import {IReduxFeaturesState} from '../../@interfaces';
import markableAsReadState from './markable-as-read/state';

const state: IReduxFeaturesState = {
    markableAsRead: markableAsReadState,
};

export default state;
